import React from 'react';
import ReactDOM from 'react-dom';
import { WorkExperienceContextContextProvider } from './context';
import { WowChallenge } from './wowchallenge';

document.querySelectorAll(".wow-challenge").forEach((elem) => {
    
    const matrixUserData = JSON.parse(elem.getAttribute('data-js-matrixUser'))

    ReactDOM.render(
        <WorkExperienceContextContextProvider>
            <WowChallenge
                matrixUserData={matrixUserData}
            />
        </WorkExperienceContextContextProvider>
    , elem);
});
